// import { useEffect, useState } from 'react';

// const useWindowSize = () => {
//   const [windowSize, setWindowSize] = useState({
//     width: undefined,
//     height: undefined,
//   });

//   useEffect(() => {
//     function handleResize() {
//       setWindowSize({
//         width: window.innerWidth,
//         height: window.innerHeight,
//       });
//     }
//     // window.addEventListener("resize", handleResize);
//     handleResize();

//     // return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return windowSize;
// };

// export default useWindowSize;
import { useEffect, useRef } from 'react';

const useWindowSize = () => {
  const windowSizeRef = useRef({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      windowSizeRef.current = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    }
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSizeRef.current;
};

export default useWindowSize;

// import { useEffect, useState } from 'react';

// const useWindowSize = () => {
//   const [windowSize, setWindowSize] = useState({
//     width: undefined,
//     height: undefined
//   });

//   useEffect(() => {
//     function handleResize() {
//       setWindowSize({
//         width: window.innerWidth,
//         height: window.innerHeight,
//       });
//     }
//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return windowSize;
// };

// export default useWindowSize;
